<template>
  <div>
    <div class="media-list">
      <el-row type="flex" align="bottom">
        <el-col :span="22">
          <div class="breadcrumb-bar">
            <el-breadcrumb separator="/">
              <el-breadcrumb-item>老师管理</el-breadcrumb-item>
            </el-breadcrumb>
          </div>
        </el-col>
      </el-row>
    </div>

    <!-- <div class="main-box searchBox">
      <el-form :inline="true" :model="formTeacher" label-width="90px" class="searchForm">
        <el-form-item label="老师:">
          <el-input v-model="formTeacher.name" placeholder="输入老师名称"></el-input>
        </el-form-item>
        <el-form-item label="老师ID:">
          <el-input v-model="formTeacher.id" placeholder="输入老师ID"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="search" @click="onQuery">搜索</el-button>
        </el-form-item>
      </el-form>
    </div> -->

    <div class="tableList">
      <el-form :inline="true" :model="formTeacher" label-width="90px" class="searchForm">
       <el-form-item label="老师ID:">
          <el-input v-model="formTeacher.id" placeholder="输入老师ID"></el-input>
        </el-form-item>
        <el-form-item label="老师:">
          <el-input v-model="formTeacher.name" placeholder="输入老师名称"></el-input>
        </el-form-item>
        
        <el-form-item>
          <el-button type="primary" icon="search" @click="onQuery">搜索</el-button>
        </el-form-item>
      </el-form>
      <div class="operBtn">
         <el-button type="primary" icon="plus" @click="addTeacher">增加老师</el-button>
      </div>
      <el-table
        ref="multipleTable"
        :data="queryData"
         :header-cell-style="rowClass"
      
        tooltip-effect="dark"
        @selection-change="handleSelectionChange"
        v-loading.body="loading"
        id="Table"
      >
        <el-table-column type="selection" width="50"></el-table-column>
        <el-table-column prop="id" label="老师ID" align="center" width="110">
          <template slot-scope="scope">
            <a
              href="javascript:;"
              @click="viewTeacher(scope.row)"
              style="color:#1d90e6"
            >{{ scope.row.id }}</a>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="老师" align="center" min-width="120">
          <template slot-scope="scope">
            <a
              href="javascript:;"
              @click="viewTeacher(scope.row)"
              style="color:#1d90e6"
            >{{ scope.row.name }}</a>
          </template>
        </el-table-column>
        <el-table-column prop="phone" label="联系方式" align="center" width="150"></el-table-column>
        <el-table-column prop="office" label="职务" align="center" width="120"></el-table-column>
        <el-table-column prop="remark" label="备注" align="center" min-width="120"></el-table-column>
        <el-table-column label="操作" show-overflow-tooltip align="center" width="100" fixed="right">
          <template slot-scope="scope">
            <el-tooltip content="编辑" placement="top">
              <el-button type="primary" size="mini" icon="el-icon-edit" @click="handleEdit(scope.row)"></el-button>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
      <div class="bottomOperBtn">
          <el-button type="danger" @click="delTeacher" icon="delete2" style="margin-top:20px">删除</el-button>
      </div>
      
      <div class="pagination-box">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="queryParams.page"
          :page-sizes="[20, 50, 100]"
          :page-size="queryParams.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pageTotal"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>


<script>
import { ApiMessage, formatDate } from "@/utils/util";
export default {
  name: "teacherList",
  data() {
    return {
      formTeacher: {
        id: "",
        name: "",
      },
      pageTotal: 0,
      queryData: [],
      queryParams: {
        page: 1,
        pageSize: 20,
      },
      multipleSelection: [],
      loading: true,
    };
  },
  components: {},
  props: {},
  created() {

    this.fetchTeacherList();
  },
  computed: {},
  filters: {
    formatDate2(d) {
      return formatDate(d, "yyyy-MM-dd hh:mm:ss");
    },
  },
  mounted() {},
  watch: {},
  methods: {
     rowClass() {
      return "background:#f9f9f9;color:#000000;font-size:14px;height:22px";
    },
    fetchTeacherList() {
      this.loading = true;
      let params = {
        appId: this.$API.APPID,
        pageSize: this.queryParams.pageSize,
        page: this.queryParams.page,
      };
      if (this.formTeacher.id != "") {
        params.id = this.formTeacher.id;
      }
      if (this.formTeacher.name != "") {
        params.name = this.formTeacher.name;
      }
      this.eduAxiosPostRequest("/edu/eduAdmin/teacher/list", params).then(
        (res) => {
          if (res != null) {
            let m = JSON.parse(res);
            this.queryData = m.list;
            console.log(this.queryData);
            this.pageTotal = m.pager.total;
          }
          this.loading = false;
        }
      );
    },
    addTeacher() {
      this.$router.push({
        name: "addTeacher",
      });
    },
    multyImport() {
      this.modalShow = true;
    },
    onQuery() {
       this.queryParams.page = 1
      this.fetchTeacherList();
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleEdit(teacher) {
      this.$router.push({
        name: "addTeacher",
        query: {
          id: teacher.id,
        },
      });
    },
    viewTeacher(teacher) {
      this.$router.push({
        name: "detailsTeacher",
        query: {
          id: teacher.id,
        },
      });
    },
    handleSizeChange(val) {
      this.queryParams.pageSize = val;
      this.fetchTeacherList();
    },
    handleCurrentChange(val) {
      this.queryParams.page = val;
      this.fetchTeacherList();
    },
    delTeacher() {
      if (this.multipleSelection.length == 0) {
        alert("请先选择老师");
        return;
      }
      this.$Modal.confirm({
        title: "确认删除？",
        content: "<ul><li>请确认是否删除所选老师</li></ul>",
        onOk: () => {
          let ids = [];
          for (let i in this.multipleSelection) {
            ids.push(`${this.multipleSelection[i].id}`);
          }
          let params = {
            appId: this.$API.APPID,
            teacherIdList: ids,
          };
          this.eduAxiosPostRequest("/edu/eduAdmin/teacher/delete", params).then(
            (res) => {
              if (res != null) {
                this.$Message.success("删除成功!");
                this.fetchTeacherList();
              }
            }
          );
        },
      });
    },
    eduAxiosPostRequest(address, params) {
      return new Promise((resolve, reject) => {
        this.$axios
          .post(address, params)
          .then((response) => {
            console.log(response);
            if (response.data.rc == "0") {
              if (address.indexOf("delete") != -1) {
                resolve(JSON.stringify(response.data.msg));
              } else {
                resolve(JSON.stringify(response.data.data));
              }
            } else {
              alert(response.data.rc + ". " + response.data.err);
              reject(null);
            }
          })
          .catch((error) => {
            ApiMessage(this, error.toString(), "error");
            reject(null);
          });
      });
    },
  },
};
</script>
<style lang="less" scoped>
@import "../fyd-style";
@import "../commonEdu";
.searchBox {
  background: #fff;
}
.table{
    margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// teacherList.vue?e510d54c